import { validateCompanyType } from "@shared/common/utils/user-form-validation";
import { Form, FormItemProps, Select, SelectProps } from "antd";

interface IFormItemInputCompanyType extends FormItemProps {
  select?: SelectProps;
}

const FormItemInputCompanyType = ({
  select,
  label,
  className,
  ...props
}: IFormItemInputCompanyType) => {
  return (
    <Form.Item
      label={label}
      name="companyType"
      rules={[
        {
          async validator(_rule, value) {
            validateCompanyType(value);
          },
        },
      ]}
      {...props}
      validateTrigger="onSubmit"
      className={className}
    >
      <Select
        placeholder="업종을 선택해 주세요."
        options={[
          { value: "쇼핑몰", label: "쇼핑몰" },
          { value: "마케팅 대행사", label: "마케팅 대행사" },
          { value: "온라인 교육", label: "온라인 교육" },
          { value: "IT 서비스", label: "IT 서비스" },
          { value: "B2B", label: "B2B" },
          { value: "오프라인 기반", label: "오프라인 기반" },
          { value: "기타", label: "기타" },
        ]}
        {...select}
        className={select?.className}
      />
    </Form.Item>
  );
};

export default FormItemInputCompanyType;
